import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e6gi5qy7n8: FaireBrandEntity = {
  token: "b_e6gi5qy7n8",
  type: "brand",
  name: "Huggalugs",
  avatarUrl:
    "https://cdn.faire.com/fastly/cb2fe4293effacadb228f010600fc80edab2415782cf3e9337ec965523dde742.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cf91e697baec5549e9e44a9c335b36833421f808c619d71aaee39d0e2c56f992.png",
  logoUrl:
    "https://cdn.faire.com/fastly/cb2fe4293effacadb228f010600fc80edab2415782cf3e9337ec965523dde742.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cf91e697baec5549e9e44a9c335b36833421f808c619d71aaee39d0e2c56f992.png",
  location: "Kirkland , WA, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 457,
  isTopShop: true,
  isInsider: true,
  description:
    "Huggalugs designs unique handknit headwear and sweaters, plus adorable bonnets and sunhats for babies and kids in happy themes and sophisticated hues. Based in Coachella Valley CA, we have served specialty stores since 2008. All of our knit hats and sweaters are hand  made by our overseas suppliers in small batches with ethical work practices.  “Where something’s produced isn’t as important as how it’s produced.” ~The Good Trade\n\nBeginning Fall 2023 we to transitioned to the incorporation of yarn made from recycled plastic bottles. The yarn is every bit as soft and beautiful as the yarn we currently use, but kinder to our environment ♻\n \nPlease don't hesitate to reach out to use with any questions you might have.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:43.035Z",
    importedBy: "entity-db-cli",
  },
};
